export default {
  hint: 'Confirme o pagamento junto do seu banco para concluir o pedido.',
  cancel: 'Cancelar pagamento',
};
